import React from "react";
import PropTypes from "prop-types";
import "./Locations.scss";
import { Trans } from "@lingui/react/macro";
import MoreLocations from "./MoreLocations";
import { buildAddress } from "../utils";
function Locations({
  selectedLocation,
  allLocations,
  store,
  selectLocation,
  shouldShowMoreLocations,
}) {
  return (
    <>
      <section className="offer-location-label">
        <p className="t-label-med">
          <Trans>Offers valid at</Trans>
        </p>
      </section>
      <section className="offer-locations">
        {shouldShowMoreLocations ? (
          <MoreLocations
            selectLocation={selectLocation}
            store={store}
            allLocations={allLocations}
            selectedLocation={selectedLocation}
          />
        ) : (
          <div className="offer-locations_current location">
            <p
              className="offer-locations_currentAddress"
              dangerouslySetInnerHTML={{
                __html: buildAddress(selectedLocation, false),
              }}
            />
          </div>
        )}
      </section>
    </>
  );
}

Locations.propTypes = {
  all_locations: PropTypes.arrayOf(PropTypes.object),
  selected_location: PropTypes.object,
  select_location: PropTypes.func,
};

export default Locations;
